<template>
  <div class="w-popup">
    <transition name="mask">
      <div class="mask" v-if="state" @click="handleClose" @touchmove.prevent></div>
    </transition>
    <transition name="fade">
      <div v-if="state" class="main">
        <slot name="content"/>
      </div>
    </transition>
  </div>
</template>

<script>
	export default {
		props: {
			state: {
				type: Boolean,
				default: false
			}
		},
		data () {
			return {}
		},
		mounted () {
		},
		computed: {},
		watch: {},
		components: {},
		methods: {
			handleClose () {
				this.$emit('handleClose')
			}
		}
	}
</script>

<style lang="scss" scoped>
  @import '@/assets/scss/global/variable';
  @import '@/assets/scss/global/mixin';

  .w-popup {
    width: 100%;
    height: 100%;
    .mask-enter-active,
    .mask-leave-active {
      transition: all 0.2s;
    }
    .mask-enter,
    .mask-leave-to {
      opacity: 1;
    }
    .mask {
      position: fixed;
      height: 100vh;
      width: 100vw;
      top: 0;
      left: 0;
      z-index: 309;
      background-color: rgba(0, 0, 0, 0.5);
    }
    .fade-enter-active,
    .fade-leave-active {
      transition: all 0.2s;
    }
    .fade-enter,
    .fade-leave-to {
      transform: translate3d(0, 100%, 0);
    }
    .main {
      position: fixed;
      left: 0;
      bottom: 0;
      z-index: 311;
      background-color: $color-light;
      border-radius: 20px 20px 0 0;
      box-sizing: border-box;
    }
  }
</style>
